import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { AddressReportActions } from "../../../store/reducers/awareness_campaigns/address_report";
import DialogWrapper from "./DialogWrapper";
import DynamicAddressForm from "./DynamicAddressForm";

export default function AddressReportModal() {
    const isAddressReportOpen = useAppSelector((state) => state.awareness_campaign.address_report.isFormOpen);

    const dispatch = useAppDispatch();

    const handleClose = () => {
        dispatch(AddressReportActions.closeReportForm());
    }

    return (
        <DialogWrapper open={isAddressReportOpen} onClose={handleClose}>
            <DynamicAddressForm />
        </DialogWrapper>
    );
}